module.exports = __webpack_public_path__ + "assets/img/beb4c7acf1ba22a46ffa410675341f45.svg";